import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  }, []);

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-main-heading">Privacy Policy</h1>
        
        <div className="privacy-content">
          <h2 className="privacy-section-title">Privacy Policy for Lutlo</h2>
          <p className="privacy-date">Effective Date: November 7, 2025</p>
          
          <p className="privacy-text">
            Lutlo ("we," "us," or "our") operates the Lutlo website. This page informs you of our policies regarding the collection, use, and disclosure of personal information.
          </p>

          <h3 className="privacy-subtitle">Information Collection and Use</h3>
          <p className="privacy-text">
            Lutlo is a simple portfolio website that showcases mobile applications published on the Google Play Store and Apple App Store. We do not collect, store, or process any personal data from visitors to our website.
          </p>

          <h3 className="privacy-subtitle">No Cookies or Tracking</h3>
          <p className="privacy-text">
            Our website does not use cookies, analytics, or any tracking technologies to monitor visitor behavior.
          </p>

          <h3 className="privacy-subtitle">Third-Party Links</h3>
          <p className="privacy-text">
            Our website may contain links to the Google Play Store and Apple App Store where our applications are listed. These external sites have their own privacy policies, and we have no control over their content or practices.
          </p>

          <h3 className="privacy-subtitle">Children's Privacy</h3>
          <p className="privacy-text">
            Our website does not knowingly collect information from children under the age of 13. Since we do not collect any data, this policy applies to all age groups.
          </p>

          <h3 className="privacy-subtitle">Changes to This Privacy Policy</h3>
          <p className="privacy-text">
            We may update our Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
          </p>

          <h3 className="privacy-subtitle">Contact Us</h3>
          <p className="privacy-text">
            If you have any questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:support@lutlo.com" className="privacy-email">support@lutlo.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;

